define("analytics-resources/components/analytics-resource/area-spline", ["exports", "@ember/component", "@ember/object", "@ember/service", "@ember/utils", "@glimmer/component", "analytics-resources/utils/charts/area-spline-chart-options", "analytics-resources/utils/charts/chart-utils", "analytics-resources/utils/math/find-min-and-max", "later/utils/time-format", "shared/utils/uuid", "@ember/template-factory"], function (_exports, _component, _object, _service, _utils, _component2, _areaSplineChartOptions, _chartUtils, _findMinAndMax, _timeFormat, _uuid, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _dec, _class, _descriptor;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@ember/utils",0,"@glimmer/component",0,"analytics-resources/utils/charts/area-spline-chart-options",0,"analytics-resources/utils/charts/chart-utils",0,"analytics-resources/utils/math/find-min-and-max",0,"later/utils/time-format",0,"shared/utils/uuid",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div {{did-insert this.chart}} {{did-update this.chart @chartData @chartState}}>
    <div>
      <div class="cSL--header">
        <h4 class="tAN--header--secondary" data-test-id={{@text.testIdTitle}}>
          {{@text.title}}
  
          <EmberTooltip @event="hover">
            <span>
              {{@text.tooltip}}
            </span>
          </EmberTooltip>
  
        </h4>
  
        {{#if (has-block "datePicker")}}
          {{yield to="datePicker"}}
        {{/if}}
      </div>
      {{#if (has-block "stats")}}
        {{yield to="stats"}}
      {{/if}}
    </div>
  
    <div class="cCH--chart" data-test-id={{@testIdChart}}>
      <div id={{this.chartId}}></div>
  
      {{#if this.showEmptyChart}}
        <div class="cCH--chart__overlay"></div>
      {{/if}}
  
      {{#if (eq @chartState "loading")}}
        <div class="cCH--chart__overlay">
          <Shared::Ui::CalculatingState
            @customColor="grey"
            @text={{t "social-listening.listener.section.loading"}}
            class="u--text--uppercase"
          />
        </div>
      {{else if (eq @chartState "backfilling")}}
        <div class="cCH--chart__overlay">
          <Shared::Ui::CalculatingState
            @customColor="grey"
            @text={{html-safe (t "social-listening.listener.section.backfilling")}}
            class="u--text--uppercase u--text--center"
          />
        </div>
      {{else if (eq @chartState "no-data")}}
        <div class="cCH--chart__overlay">
          <p class="u--m__b__0">
            {{t "analytics-resources.state.no_insights"}}
          </p>
        </div>
      {{else if (eq @chartState "error")}}
        <div class="cCH--chart__overlay">
          {{#if (has-block "errorOverlay")}}
            {{yield to="errorOverlay"}}
          {{else}}
            <p class="u--m__b__0">
              {{t "analytics-resources.state.error"}}
            </p>
          {{/if}}
        </div>
      {{else if (eq @chartState "refresh-profile")}}
        <Listener::Charts::RefreshCredentials />
      {{/if}}
    </div>
  </div>
  */
  {
    "id": "FxzM+jMO",
    "block": "[[[11,0],[4,[38,0],[[30,0,[\"chart\"]]],null],[4,[38,1],[[30,0,[\"chart\"]],[30,1],[30,2]],null],[12],[1,\"\\n  \"],[10,0],[12],[1,\"\\n    \"],[10,0],[14,0,\"cSL--header\"],[12],[1,\"\\n      \"],[10,\"h4\"],[14,0,\"tAN--header--secondary\"],[15,\"data-test-id\",[30,3,[\"testIdTitle\"]]],[12],[1,\"\\n        \"],[1,[30,3,[\"title\"]]],[1,\"\\n\\n        \"],[8,[39,2],null,[[\"@event\"],[\"hover\"]],[[\"default\"],[[[[1,\"\\n          \"],[10,1],[12],[1,\"\\n            \"],[1,[30,3,[\"tooltip\"]]],[1,\"\\n          \"],[13],[1,\"\\n        \"]],[]]]]],[1,\"\\n\\n      \"],[13],[1,\"\\n\\n\"],[41,[48,[30,5]],[[[1,\"        \"],[18,5,null],[1,\"\\n\"]],[]],null],[1,\"    \"],[13],[1,\"\\n\"],[41,[48,[30,6]],[[[1,\"      \"],[18,6,null],[1,\"\\n\"]],[]],null],[1,\"  \"],[13],[1,\"\\n\\n  \"],[10,0],[14,0,\"cCH--chart\"],[15,\"data-test-id\",[30,4]],[12],[1,\"\\n    \"],[10,0],[15,1,[30,0,[\"chartId\"]]],[12],[13],[1,\"\\n\\n\"],[41,[30,0,[\"showEmptyChart\"]],[[[1,\"      \"],[10,0],[14,0,\"cCH--chart__overlay\"],[12],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[28,[37,6],[[30,2],\"loading\"],null],[[[1,\"      \"],[10,0],[14,0,\"cCH--chart__overlay\"],[12],[1,\"\\n        \"],[8,[39,7],[[24,0,\"u--text--uppercase\"]],[[\"@customColor\",\"@text\"],[\"grey\",[28,[37,8],[\"social-listening.listener.section.loading\"],null]]],null],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],[[[41,[28,[37,6],[[30,2],\"backfilling\"],null],[[[1,\"      \"],[10,0],[14,0,\"cCH--chart__overlay\"],[12],[1,\"\\n        \"],[8,[39,7],[[24,0,\"u--text--uppercase u--text--center\"]],[[\"@customColor\",\"@text\"],[\"grey\",[28,[37,9],[[28,[37,8],[\"social-listening.listener.section.backfilling\"],null]],null]]],null],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],[[[41,[28,[37,6],[[30,2],\"no-data\"],null],[[[1,\"      \"],[10,0],[14,0,\"cCH--chart__overlay\"],[12],[1,\"\\n        \"],[10,2],[14,0,\"u--m__b__0\"],[12],[1,\"\\n          \"],[1,[28,[35,8],[\"analytics-resources.state.no_insights\"],null]],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],[[[41,[28,[37,6],[[30,2],\"error\"],null],[[[1,\"      \"],[10,0],[14,0,\"cCH--chart__overlay\"],[12],[1,\"\\n\"],[41,[48,[30,7]],[[[1,\"          \"],[18,7,null],[1,\"\\n\"]],[]],[[[1,\"          \"],[10,2],[14,0,\"u--m__b__0\"],[12],[1,\"\\n            \"],[1,[28,[35,8],[\"analytics-resources.state.error\"],null]],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]]],[1,\"      \"],[13],[1,\"\\n\"]],[]],[[[41,[28,[37,6],[[30,2],\"refresh-profile\"],null],[[[1,\"      \"],[8,[39,10],null,null,null],[1,\"\\n    \"]],[]],null]],[]]]],[]]]],[]]]],[]]],[1,\"  \"],[13],[1,\"\\n\"],[13]],[\"@chartData\",\"@chartState\",\"@text\",\"@testIdChart\",\"&datePicker\",\"&stats\",\"&errorOverlay\"],false,[\"did-insert\",\"did-update\",\"ember-tooltip\",\"if\",\"has-block\",\"yield\",\"eq\",\"shared/ui/calculating-state\",\"t\",\"html-safe\",\"listener/charts/refresh-credentials\"]]",
    "moduleName": "analytics-resources/components/analytics-resource/area-spline.hbs",
    "isStrictMode": false
  });
  let AreaSplineComponent = _exports.default = (_dec = (0, _service.inject)('highcharts-library'), (_class = class AreaSplineComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "highchartsLibrary", _descriptor, this);
      _defineProperty(this, "chartId", `growth-chart-area-spline-${(0, _uuid.default)()}`);
    }
    get showEmptyChart() {
      return (0, _chartUtils.showEmptyChart)(this.args.chartState);
    }
    get showTickPositions() {
      return !this.showEmptyChart && this.durationShorterThanTwoWeeks;
    }
    get seriesColor() {
      if (this.hasOnlyOneDataPoint) {
        return 'cCH--chartColor';
      }
      return this.args.color ? `cCH--chartColor__${this.args.color}` : 'cCH--chartColor';
    }
    get hasOnlyOneDataPoint() {
      return this.args.chartData?.filter(_ref => {
        let [, value] = _ref;
        return (0, _utils.isPresent)(value);
      }).length === 1;
    }
    get durationShorterThanTwoWeeks() {
      if (!this.args.chartData) {
        return false;
      }
      const firstTime = this.args.chartData[0][0];
      const endTime = this.args.chartData[this.args.chartData.length - 1][0];
      return endTime - firstTime < _timeFormat.convert.days(14).toSeconds();
    }
    get minYAxisValue() {
      return this.args.chartOptions.overrideYAxisRange?.min || 0;
    }
    get maxYAxisValue() {
      return this.args.chartOptions.overrideYAxisRange?.max || (this.args.chartData ? (0, _findMinAndMax.default)(this.args.chartData).max : null);
    }
    get chartNullData() {
      return this.args.chartNullData ?? [];
    }
    get chartData() {
      return this.args.chartData ?? [];
    }
    get chartOptions() {
      return {
        ...this.commonOptions,
        chart: {
          ...this.commonOptions.chart,
          className: this.args.customChartClass || 'detailed-y-chart'
        },
        xAxis: {
          type: 'datetime',
          crosshair: true,
          labels: this.args.chartOptions.xAxisLabels || {},
          tickPositions: this.showTickPositions ? this.args.chartOptions.tickPositions : undefined,
          lineWidth: 0,
          minorGridLineWidth: 0,
          lineColor: 'transparent',
          minorTickLength: 0,
          tickLength: 0,
          plotBands: this.args.chartOptions.plotBands || []
        },
        yAxis: {
          ...this.commonOptions.yAxis,
          minRange: 0.1,
          startOnTick: false,
          labels: {
            overflow: 'justify',
            reserveSpace: false,
            x: 0,
            align: 'left'
          },
          min: this.minYAxisValue,
          max: this.maxYAxisValue
        },
        tooltip: {
          shape: 'square',
          shadow: false,
          useHTML: true,
          padding: 6,
          formatter: this.args.chartOptions.tooltipFormatter
        },
        series: [{
          type: 'areaspline',
          data: this.chartData,
          name: this.args.text.series,
          className: this.seriesColor,
          clip: false,
          zoneAxis: this.args.chartOptions.zoneAxis || undefined,
          zones: this.args.chartOptions.zones || undefined,
          threshold: this.args.chartOptions.threshold || null,
          marker: {
            enabled: this.hasOnlyOneDataPoint,
            radius: 2,
            symbol: 'circle'
          }
        }, {
          type: 'spline',
          data: this.chartNullData,
          name: this.args.text.series,
          className: `${this.seriesColor} cCH--chartDash`,
          clip: false,
          zoneAxis: this.args.chartOptions.zoneAxis || undefined,
          zones: this.args.chartOptions.zones || undefined,
          threshold: this.args.chartOptions.threshold || null,
          enableMouseTracking: false
        }],
        defs: this.args.chartOptions.showGradient ? (0, _areaSplineChartOptions.getGradientDefinition)(this.args.color) : undefined
      };
    }
    get emptyChartOptions() {
      return {
        ...this.commonOptions,
        chart: {
          ...this.commonOptions.chart,
          className: 'cCH--chart--disabled'
        },
        xAxis: {
          type: 'linear',
          labels: {
            enabled: false
          },
          tickLength: 0,
          crosshair: false,
          className: 'cCH--chart--disabled'
        },
        yAxis: {
          ...this.commonOptions.yAxis,
          labels: {
            enabled: false
          }
        },
        tooltip: {
          enabled: false
        },
        series: [{
          type: 'areaspline',
          data: [[0, 4], [1, 6]],
          name: this.args.text.series,
          className: 'cCH--chart--disabled',
          clip: false
        }]
      };
    }
    get commonOptions() {
      return {
        title: undefined,
        chart: {
          styledMode: true,
          height: this.args.chartOptions.height || 170,
          spacing: [25, 0, 0, 0]
        },
        credits: {
          enabled: false
        },
        legend: {
          enabled: false
        },
        yAxis: {
          allowDecimals: false,
          title: undefined
        },
        plotOptions: {
          series: {
            animation: false,
            marker: {
              enabled: false
            },
            states: {
              hover: {
                enabled: false
              }
            }
          }
        }
      };
    }
    chart() {
      const chartOptions = this.showEmptyChart ? this.emptyChartOptions : this.chartOptions;
      this.highchartsLibrary.chart(this.chartId, chartOptions);
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "highchartsLibrary", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "chart", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "chart"), _class.prototype)), _class));
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, AreaSplineComponent);
});